import { IPage } from 'src/app/models/page.interface';
import {environment} from '../../../environments/environment';

export interface IPageState {
  page: IPage;
}

export const initialPageState: IPageState = {
  page: {
    countryMenu: 0,
    typeMenu: 'ALL',
    systemBetMenu: null,
    openRace: false,
    openNoOddRace: false,
    closeRace: false,
    cartTabIndex: 0,
    menuTabIndex: 0,
    loading: false,
    loadingMenu: false,
    placeSelected: '',
    fullScreen: false,
    showCart: false,
    showMenu: true,
    showLast: false,
    showBonus: false,
    session: '',
    cid: '',
    firstStreaming: {
      id: 1,
      link: '',
    },
    coverVideo: 'assets/img/screen-video-horse-en.png',
    ip: '',
    urllogo: '',
    imageshome: [
      {
        link: '',
        // url: environment.staging ? 'assets/img/blank-video.jpg' : 'assets/img/blank-video-prod.jpg',
        url: environment.staging ? 'assets/img/blank-video.jpg' : '',
      },
    ],
    imagescart: [
      {
        link: '',
        // url: '',
        url: environment.staging ? 'assets/img/blank-video.jpg' : '',
      },
    ],
    trackGA: '',
    videoEnabled: true,
    playVideo: true,
    disableaudio: false,
    playerRace:
      {
        countryid: 0,
        country: '',
        tp: '',
        course: '',
        midRacePage: 0,
        channel: ''
      },
    showTicketList: true,
    functionCompleteBet: '',
    functionButtonBet: '',
    freebetSingle: {
      id: '',
      stake: 0,
      valid_from: '',
      valid_until: '',
      name: '',
      speciality: '',
      sigla: '',
      id_meeting: '0',
      id_race: '0',
      min_odd: 0,
      max_odd: 0,
      s_min: 0,
      s_max: 0,
      net_payout: 0,
      type: 0,
    },
    freebetMultiple: {
      id: '',
      stake: 0,
      valid_from: '',
      valid_until: '',
      name: '',
      speciality: '',
      sigla: '',
      id_meeting: '0',
      id_race: '0',
      min_odd: 0,
      max_odd: 0,
      s_min: 0,
      s_max: 0,
      net_payout: 0,
      type: 0,
    },
    freebetSystem: {
      id: '',
      stake: 0,
      valid_from: '',
      valid_until: '',
      name: '',
      speciality: '',
      sigla: '',
      id_meeting: '0',
      id_race: '0',
      min_odd: 0,
      max_odd: 0,
      s_min: 0,
      s_max: 0,
      net_payout: 0,
      type: 0,
    },
    bonusSingle: false,
    bonusMultiple: false,
    bonusSystem: false,
    count: {
      countGL: 0,
      countTR: 0,
      countGH: 0,
      countTOT: 0,
      countQF: 0,
      countTRIS: 0,
    },
    reminder: {
      giocata: []
    },
    favorites: [],
    hidefullstats: false,
    terminalTag: 0,
    errorPage: null,
    confirmBetState: false,
    today: true
  },
};
